export function addRegistrationFormEvent(formRegistrationAction: 'failedFormSubmission' | 'succeedFormSubmission') {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer.push({
    event: 'registrationForm',
    formRegistrationAction,
  });
}
